import angular from 'angular'
import { DISPLAY_STATUSES } from '../models/sale.constants'

/**
 * Filter for getting the status of a Sale.
 *
 * @module webregister.filters.wrSaleStatus
 */
angular.module('webregister.filters').filter('wrSaleStatus', function () {
  /*
   * Get the display equivalent of the given sale's status (e.g. "Parked" for SAVED status).
   *
   * @method
   *
   * @param  sale {Sale|String}
   *         The sale to get the status of or the sale status to format
   *
   * @param  [noStatus='–'] {String}
   *         The string to return if the status is not defined or unrecognised
   *
   * @return {String} The status of the given sale suitable for display
   */
  return function (sale: $TSFixMe, noStatus = '–') {
    const status = (sale && (sale.displayStatus || sale.status)) || sale
    return DISPLAY_STATUSES[status] || noStatus
  }
})
